import { render, staticRenderFns } from "./product-manage.vue?vue&type=template&id=71ee62ec&scoped=true&"
import script from "./product-manage.vue?vue&type=script&lang=js&"
export * from "./product-manage.vue?vue&type=script&lang=js&"
import style0 from "./product-manage.vue?vue&type=style&index=0&id=71ee62ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ee62ec",
  null
  
)

export default component.exports